import script from "./AppLayoutSidebarEntry.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayoutSidebarEntry.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayoutSidebarEntry.vue?vue&type=style&index=0&id=54ad6def&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ad6def"]])

export default __exports__